var _style, _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordWhiteBlackLogos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1DC100;}\n\t.st1{fill:#EDE107;}\n\t.st2{fill:#F41414;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 18.366 387.4728)",
    className: "st0",
    cx: 299.1,
    cy: 180,
    rx: 29.9,
    ry: 29.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -55.1821 277.4135)",
    className: "st1",
    cx: 180,
    cy: 180,
    rx: 29.9,
    ry: 29.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -128.7301 167.3543)",
    className: "st2",
    cx: 60.9,
    cy: 180,
    rx: 29.9,
    ry: 29.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.7,180L97.7,180L97.7,180C97.7,180,97.7,180,97.7,180L97.7,180z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.3,180L262.3,180L262.3,180C262.3,180,262.3,180,262.3,180L262.3,180z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -413.2672 -667.5125)",
    className: "st0",
    cx: -706.1,
    cy: -24.5,
    rx: 29,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -547.3013 -868.0869)",
    className: "st1",
    cx: -923.2,
    cy: -24.5,
    rx: 29,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -672.8298 -1055.9512)",
    className: "st2",
    cx: -1126.6,
    cy: -24.5,
    rx: 29,
    ry: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-758-24.5L-758-24.5L-758-24.5c0-25.8,18.9-47.2,43.6-51.2c4.8-0.8,8.2-5,8.2-9.8v-28.9 c0-5.9-5.1-10.6-11-9.9c-50.3,5.5-89.5,48.1-89.5,99.8l0,0v90.5c0,5.5,4.5,10,10,10h28.7c5.5,0,10-4.5,10-10 C-758,45.2-758-2.5-758-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-654.4-24L-654.4-24L-654.4-24c0,25.8-18.9,47.2-43.6,51.2c-4.8,0.8-8.2,5-8.2,9.8v28.9 c0,5.9,5.1,10.6,11,9.9c50.3-5.5,89.4-48.1,89.4-99.8l0,0v-162.2c0-5.5-4.5-10-10-10h-28.7c-5.5,0-10,4.4-10,9.9 C-654.4-153.2-654.4-48-654.4-24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-968.8-24.5L-968.8-24.5L-968.8-24.5C-968.8-24.5-968.8-24.5-968.8-24.5L-968.8-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-865.2-24.5L-865.2-24.5L-865.2-24.5L-865.2-24.5L-865.2-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-865.2-24.5L-865.2-24.5L-865.2-24.5C-865.2-24.5-865.2-24.5-865.2-24.5L-865.2-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-968.8-24.5L-968.8-24.5L-968.8-24.5L-968.8-24.5L-968.8-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-822.8-24.5c0-36.5-19.5-68.5-48.6-86c-15.1-9.1-32.8-14.4-51.8-14.4s-36.7,5.3-51.8,14.4 c-29.1,17.6-48.6,49.5-48.6,86l0,0c0,36.5,19.5,68.5,48.6,86c15.1,9.1,32.8,14.4,51.8,14.4s36.7-5.3,51.8-14.4 C-842.3,44-822.8,12-822.8-24.5L-822.8-24.5L-822.8-24.5L-822.8-24.5z M-871.5-24.5L-871.5-24.5c0,28.6-23.2,51.8-51.8,51.8 c-28.6,0-51.8-23.2-51.8-51.8v0l0,0v0c0-28.6,23.2-51.8,51.8-51.8S-871.5-53.1-871.5-24.5C-871.5-24.5-871.5-24.5-871.5-24.5 L-871.5-24.5L-871.5-24.5L-871.5-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1073.9-1c-3.7,0-7.3,1.8-9.3,4.9c-9.3,14.1-25.2,23.4-43.3,23.4c-28.6,0-51.8-23.2-51.8-51.8v0l0,0v0 c0-28.6,23.2-51.8,51.8-51.8c18.1,0,34,9.3,43.3,23.4c2,3.1,5.6,4.9,9.3,4.9h29.3c8.2,0,13.6-8.4,10.4-16 c-8.3-19.4-22.6-35.7-40.5-46.5c-15.1-9.1-32.8-14.4-51.8-14.4c-19,0-36.7,5.3-51.8,14.4c-29.1,17.6-48.6,49.5-48.6,86l0,0 c0,36.5,19.5,68.5,48.6,86c15.1,9.1,32.8,14.4,51.8,14.4c18.9,0,36.7-5.3,51.8-14.4c17.9-10.8,32.2-27.1,40.5-46.5 c3.2-7.5-2.2-16-10.4-16L-1073.9-1L-1073.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1238.9,4.7c-0.8-3-4.8-3.5-6.5-0.9c-2,3-4.3,6.3-6.3,8.3c-14.2,14.2-34.7,18.4-52.6,12.6l44.5-44.5 l12.4-12.4c2.9-2.9,4.8-6.6,5.4-10.6c2.3-15.5,7.6-30,15.5-42.8c4.3-7.1,2.4-16.5-4.4-21.2c-24.2-16.9-54.1-22-81.7-15.1 c-17.1,4.2-33.4,13.1-46.8,26.5c-13.4,13.4-22.2,29.6-26.5,46.8c-8.2,33,0.6,69.4,26.5,95.2l0,0c25.8,25.8,62.2,34.6,95.2,26.5 c14.6-3.6,28.5-10.5,40.5-20.7c3.7-3.1,4.3-8.5,1.6-12.4C-1229.5,29.3-1235.3,17.5-1238.9,4.7z M-1324.9-61.2 c14.2-14.2,34.7-18.4,52.6-12.6l-65.2,65.2C-1343.4-26.5-1339.1-46.9-1324.9-61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1388.7-96.3L-1388.7-96.3c0-36.5-19.5-68.5-48.6-86c-15.1-9.1-32.8-14.4-51.8-14.4l0,0l0,0 c-2.1,0-4.2,0.1-6.3,0.2c-0.6,0-1.2,0.1-1.8,0.1c-1.7,0.1-3.4,0.3-5.1,0.5c-0.4,0-0.9,0.1-1.3,0.2c-2,0.3-4.1,0.6-6.1,1.1 c-0.3,0.1-0.5,0.1-0.8,0.2c-1.8,0.4-3.5,0.8-5.2,1.3c-0.5,0.1-1,0.3-1.5,0.4c-1.7,0.5-3.3,1-5,1.6c-0.3,0.1-0.6,0.2-0.9,0.3 c-1.9,0.7-3.9,1.5-5.8,2.3c-0.3,0.1-0.6,0.3-0.8,0.4c-1.6,0.7-3.2,1.5-4.8,2.3c-0.4,0.2-0.8,0.4-1.2,0.6c-1.8,0.9-3.5,1.9-5.3,2.9 l0,0c0-2.5,0-4.7,0-6.7c0-4.3-3.5-7.7-7.7-7.7h-33.1c-4.3,0-7.7,3.5-7.7,7.7V65.9c0,5.5,4.5,10,10,10h28.6c5.5,0,10-4.5,10-10 c0-15.1,0-45.4,0-76.1l0,0c1.7,1,3.5,2,5.3,2.9c0.4,0.2,0.8,0.4,1.2,0.6c1.6,0.8,3.2,1.5,4.8,2.3c0.3,0.1,0.6,0.3,0.8,0.4 c1.9,0.8,3.8,1.6,5.8,2.3c0.3,0.1,0.6,0.2,0.9,0.3c1.6,0.6,3.3,1.1,4.9,1.6c0.5,0.1,1,0.3,1.6,0.4c1.7,0.5,3.5,0.9,5.2,1.3 c0.3,0.1,0.5,0.1,0.8,0.2c2,0.4,4,0.8,6.1,1.1c0.4,0.1,0.9,0.1,1.3,0.2c1.7,0.2,3.4,0.4,5.1,0.5c0.6,0,1.2,0.1,1.8,0.1 c2.1,0.1,4.2,0.2,6.3,0.2l0,0l0,0c28.6,0,51.8,23.2,51.8,51.8v0v14.9c0,2.8,2.3,5.1,5.1,5.1h33.6c5.5,0,10-4.5,10-10V56 c0-30.5-13.6-57.7-35-76.1C-1402.3-38.6-1388.7-65.8-1388.7-96.3z M-1489.2-44.4c-28.6,0-51.8-23.2-51.8-51.8s23.2-51.8,51.8-51.8 s51.8,23.2,51.8,51.8S-1460.6-44.4-1489.2-44.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordWhiteBlackLogos);
export default __webpack_public_path__ + "static/media/Record_White_Black_Logos.a4f778eee98b69f42630ccdb3f8e991e.svg";
export { ForwardRef as ReactComponent };